"use client";

import Link from "next/link";
import Image from "next/image";
import { motion } from "framer-motion";
import { BgLayer } from "./bg/BgPrimitives";

export default function ForPartners() {
  return (
    <section id="partners" className="relative overflow-hidden bg-[#bbd153] py-16 px-4">
      <BgLayer>
        <div className="absolute inset-0" style={{
          backgroundImage: `linear-gradient(color-mix(in srgb, var(--color-primary) 8%, transparent) 1px, transparent 1px), linear-gradient(90deg, color-mix(in srgb, var(--color-primary) 8%, transparent) 1px, transparent 1px)`,
          backgroundSize: "32px 32px",
          WebkitMaskImage: "linear-gradient(to left, black, transparent 70%)",
          maskImage: "linear-gradient(to left, black, transparent 70%)",
        }}/>
      </BgLayer>
      <div className="container mx-auto relative z-10">
        <div className="flex flex-col md:flex-row items-center gap-10 md:gap-16">
          {/* Left: text */}
          <motion.div
            className="flex-1"
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, amount: 0.25 }}
            transition={{ duration: 0.55, ease: [0.25, 0.46, 0.45, 0.94] }}
          >
            <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
              For schools, universities, and partners
            </h2>
            <p className="text-foreground/80 text-base leading-relaxed">
              This program is designed to help young people build practical financial skills through a
              flexible digital learning experience combined with a live applied component. It can
              support schools, universities, and youth-focused partners looking for engaging and
              accessible financial literacy content that connects learning to real-life decisions.
            </p>
            <motion.div
              className="flex gap-4 flex-wrap mt-6"
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.4, delay: 0.2 }}
            >
              <Link
                href="mailto:info@injaz.org"
                className="bg-secondary text-white hover:bg-secondary/90 rounded-full px-6 py-2 text-sm font-medium hover:shadow-lg hover:scale-105 hover:-translate-y-0.5 active:scale-95 transition-all duration-150"
              >
                Partner with us
              </Link>
              <Link
                href="mailto:info@injaz.org"
                className="border border-secondary text-foreground bg-transparent hover:bg-secondary/15 rounded-full px-6 py-2 text-sm font-medium hover:scale-105 hover:-translate-y-0.5 active:scale-95 transition-all duration-150"
              >
                Contact us
              </Link>
            </motion.div>
          </motion.div>

          {/* Right: photo */}
          <motion.div
            className="flex-1 flex justify-center md:justify-end"
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, amount: 0.25 }}
            transition={{ duration: 0.55, delay: 0.1, ease: [0.25, 0.46, 0.45, 0.94] }}
          >
            <Image
              src="/images/landing/partners-photo.jpg"
              alt="Schools, universities and partners"
              width={520}
              height={380}
              className="rounded-2xl object-cover w-full max-w-md shadow-lg"
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
}
